import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  VbWithdrawalInstructionsFormGroup,
  VbWithdrawalStepFormGroup
} from '../../../../../models/shared/forms/vb-withdrawal-step-form-group';
import { FundType } from '../../../../../models/transactions/fund-type';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-variable-benefit-review-withdrawal-details',
  templateUrl: './variable-benefit-review-withdrawal-details.component.html',
  styleUrls: ['./variable-benefit-review-withdrawal-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitReviewWithdrawalDetailsComponent implements OnChanges {
  @Input() withdrawalInstructionsFormGroup!: VbWithdrawalStepFormGroup;
  @Input() fundTypes!: FundType[];

  private _instructions = new BehaviorSubject<VbWithdrawalInstructionsFormGroup[]>([]);
  public sortedInstructions$ = this._instructions.pipe(
    map(instructions => [...instructions].sort((a, b) => a.controls.fund.value - b.controls.fund.value))
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.withdrawalInstructionsFormGroup) {
      const controls = this.withdrawalInstructionsFormGroup?.controls?.instructions?.controls ?? [];
      this._instructions.next(controls);
    }
  }
}
